"use strict";

EWS.Ready(() => {
    if (UserType !== "Guest") {
        InitEncompassHelp();
    }
});

function InitEncompassHelp() {
    const pageHeader = document.querySelector("#Header .Inner");

    if (pageHeader) {
        const ecpHelpButton = EC_Fmt.HtmlStrToElement("<div class=\"IconButton ecp-help-button\"><span class=ews-icon-emquicktour></span></div>");
        pageHeader.appendChild(ecpHelpButton);

        ecpHelpButton.addEventListener("click", () => {
            const ecpHelpDialog = document.querySelector(".ecp-help-dialog");

            if (ecpHelpDialog) {
                ToggleEncompassHelpDisplay(ecpHelpDialog);
            } else {
                WriteEncompassHelpDialog();
            }
        });
    }
}

async function WriteEncompassHelpDialog() {
    const html = "<div class=ecp-help-dialog style=width:0>"
        + "<div class=ecp-help-container>"
        + "<div class=ecp-help-search>"
        + "<ecp-input id=ecp-help-input type=text icon=ews-icon-search placeholder=Search width=100%></ecp-input>"
        + "</div>"
        + "<div class=ecp-help-content></div>"
        + "</div>"
        + "</div>";

    const ecpHelpDialog = EC_Fmt.HtmlStrToElement(html);

    ecpHelpDialog.addEventListener("transitionend", (event) => {
        if (event.currentTarget.offsetWidth === 0) {
            event.currentTarget.style.display = "none";
        }
    });

    document.querySelector("#Content .Inner").appendChild(ecpHelpDialog);

    const timer = setTimeout(() => {
        ECP.Dialog.ShowLoading("", ecpHelpDialog.querySelector(".ecp-help-content"));
    }, 1000);

    requestAnimationFrame(() => {
        ecpHelpDialog.style.width = null;

        EC_Fmt.AfterInput(ecpHelpDialog.querySelector("input#ecp-help-input"), 0, 350, async (input, search) => {
            if (search.length >= 3) {
                const myRequest = new ECP.EC_Request("EncompassHelp_HelpResourcesSearch");
                myRequest.AddRequestVariable("SearchStr", search);

                const result = await myRequest.Submit();
                WriteEncompassHelpContent(result);
            } else if (search.length === 0) {
                WriteCurrentHelpResources();
            }
        });
    });

    document.body.removeEventListener("click", ClickOtherToHide);
    document.body.addEventListener("click", ClickOtherToHide);

    WriteCurrentHelpResources(timer);
}

async function WriteCurrentHelpResources(timer) {
    const myRequest = new ECP.EC_Request("EncompassHelp_GetCurrentHelpResources");
    myRequest.AddRequestVariable("DashboardID", Settings.DashboardID);

    if (Settings.DashboardID === ECP.CommonDashboards.TableView) {
        myRequest.AddRequestVariable("TableName", EC_Fmt.GetPageParameter("TableName"));
    }

    const result = await myRequest.Submit();

    clearTimeout(timer);
    WriteEncompassHelpContent(result);
}

function WriteEncompassHelpContent(result) {
    const ecpHelpContent = document.querySelector(".ecp-help-dialog .ecp-help-content");
    ecpHelpContent.innerHTML = "";

    if (result && result.length > 0 && Object.keys(result[0]).length > 0) {
        let html = "";

        for (let i = 0; i < result.length; i++) {
            const ApplicationObj = result[i];

            html += `<div class=help-card application-index=${i}>`;
            html += `<div class=help-application-title><div style=flex:1>${ApplicationObj.Application}</div><i class="ews-icon-emcaretdown arrowup"></i></div>`;
            html += "<div class=help-application-content>";

            for (let j = 0; j < ApplicationObj.HelpResources.length; j++) {
                const HelpResourcesObj = ApplicationObj.HelpResources[j];

                if (j !== 0) {
                    html += "<div class=help-card-line></div>";
                }

                html += `<div class=help-resources resources-index=${j}>`;
                html += `<div class=help-resources-title>${HelpResourcesObj.Title}</div>`;

                for (let k = 0; k < HelpResourcesObj.HelpResourcesVersions.length; k++) {
                    const HelpResourcesVersionsObj = HelpResourcesObj.HelpResourcesVersions[k];

                    html += `<div class=help-resources-version version-index=${k}>`;

                    if (HelpResourcesVersionsObj.YouTubeLink) {
                        html += "<div class=versionText data=YouTubeLink style=\"margin-left:18px;margin-right:5px\">Video</div>";
                    }

                    html += "<ecp-btn type=ghost class=help-guide>Guide</ecp-btn>";
                    html += "<div class=help-guide-content style=display:none>";

                    if (HelpResourcesVersionsObj.PreConditions) {
                        html += "<div class=versionText data=PreConditions>Preconditions</div>";
                    }
                    if (HelpResourcesVersionsObj.Steps) {
                        html += "<div class=versionText data=Steps>Steps</div>";
                    }
                    if (HelpResourcesVersionsObj.FieldsAndDefinitions) {
                        html += "<div class=versionText data=FieldsAndDefinitions>Definitions</div>";
                    }
                    if (HelpResourcesVersionsObj.BestPractices) {
                        html += "<div class=versionText data=BestPractices>Best Practices</div>";
                    }
                    if (HelpResourcesVersionsObj.PDFLink) {
                        html += `<div class=versionText data=PDFLink>PDF</div>`;
                    }

                    html += "</div>";
                    html += "</div>";
                }

                html += "</div>";
            }

            html += "</div>";
            html += "</div>";
        }

        ecpHelpContent.innerHTML = html;

        const titleArr = ecpHelpContent.querySelectorAll(".help-card");
        for (let i = 0; i < titleArr.length; i++) {
            titleArr[i].addEventListener("click", EncompassHelpCardClickEvent(result));
        }
    } else {
        ecpHelpContent.innerHTML = "<ecp-empty illustration=search>"
            + "<ecp-empty-title>No data returned </ecp-empty-title>"
            + "<ecp-empty-body>Try adjusting your search to find what you’re looking for </ecp-empty-body>"
            + "</ecp-empty>";
    }

    ECP.Dialog.HideLoading();
}

function EncompassHelpCardClickEvent(data) {
    return function (event) {
        const target = event.target;

        if (target.closest(".help-application-title")) {
            const title = target.closest(".help-application-title");
            const icon = title.querySelector(".ews-icon-emcaretdown");
            const applicationContent = title.nextElementSibling;

            if (applicationContent.offsetHeight > 0) {
                applicationContent.style.display = "none";
                icon.classList.remove("arrowup");
            } else {
                applicationContent.style.display = null;
                icon.classList.add("arrowup");
            }
        } else if (target.closest(".help-guide")) {
            const guideContent = target.closest(".help-guide").nextElementSibling;
            if (guideContent.offsetHeight > 0) {
                guideContent.style.display = "none";
            } else {
                guideContent.style.display = null;
            }
        } else if (target.closest(".versionText[data]")) {
            const field = target.getAttribute("data");
            const applicationIndex = target.closest("[application-index]").getAttribute("application-index");
            const resourcesIndex = target.closest("[resources-index]").getAttribute("resources-index");
            const versionIndex = target.closest("[version-index]").getAttribute("version-index");

            let content = data[applicationIndex].HelpResources[resourcesIndex].HelpResourcesVersions[versionIndex][field];

            if (field === "YouTubeLink" || field === "PDFLink") {
                const embedLink = `https://www.youtube.com/embed${content.substr(content.lastIndexOf("/"))}`;
                content = `<iframe width=960 height=540 src="${embedLink}"></iframe><div style=margin-top:10px><a href="${content}" target=_blank><span class=ews-icon-externallink></span> External Link</a></div>`;
            }

            ECP.Dialog.ShowDialog(target.innerText, content, {
                disableButtons: true
            });
        }
    };
}

function ToggleEncompassHelpDisplay(ecpHelpDialog) {
    if (ecpHelpDialog.offsetWidth > 0) {
        ecpHelpDialog.style.width = "0";
    } else {
        ecpHelpDialog.style.display = "";

        requestAnimationFrame(() => {
            ecpHelpDialog.style.width = null;
        });
    }
}

function ClickOtherToHide(event) {
    const ecpHelpDialog = document.querySelector(".ecp-help-dialog");

    if (ecpHelpDialog && ecpHelpDialog.offsetWidth > 0 && !event.target.closest(".ecp-help-dialog") && !event.target.closest(".ecp-dialog")) {
        ecpHelpDialog.style.width = "0";
    }
}
